import { render, staticRenderFns } from "./svgTelegram.vue?vue&type=template&id=9f9b4efc&scoped=true"
import script from "./svgTelegram.vue?vue&type=script&lang=js"
export * from "./svgTelegram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f9b4efc",
  null
  
)

export default component.exports